<script setup lang=ts>
import Normal from './Normal.vue';
import Pinned from './Pinned.vue';
import Column from './Column.vue';

const props = defineProps({
  isColumn: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="h-642 flex gap-32">
    <Column class="flex-shrink-0" v-if="props.isColumn" />
    <Pinned class="flex-shrink-0" v-else />
    <Normal class="flex-shrink-0" :is-selected="props.isColumn" />
  </div>
</template>

<style lang="scss" scoped>
</style>
